<template>
<div>
    <base-multi-select v-model="values" :placeholder="$t('searchOrSelectOptions')" label="name" searchable filtered :options="options" />
    <base-button class="mt-3" @click="updateActiveVars">{{ $t('save') }}</base-button>
</div>
</template>

<script>
import ClinicHistoryRepository from '../../repositories/ClinicHistoryRepository'
import BaseMultiSelect from '@/components/base/forms/BaseMultiSelect'
import { GLUCOSE, BLOOD_PRESSURE, HEART_RATE, HDL_CHOLESTEROL, LDL_CHOLESTEROL, TRIGLYCERIDES, BREATHING_FREQUENCY, OXYGEN_SATURATION, WAIST_SIZE, HIP_SIZE, FAT_MASS, FREE_FAT_MASS, HOMA, VITAMIN_D, STEPS_NUMBER, CALORIES, BODY_MASS_INDEX, BLOOD_TYPE } from '@/constants/clinicHistory'

export default {
    props: {
        activeVars: Array
    },
    components: {
        BaseMultiSelect
    },
    created () {
        this.values = this.activeVars.filter(value => this.options.some(item => item.value === value))
    },
    data () {
        return {
            values: []
        }
    },
    computed: {
        options () {
            return this.$route.query.petId ? [{name: this.$t(`${BLOOD_TYPE}`), value: BLOOD_TYPE}] : [{name: this.$t(`${BLOOD_PRESSURE}`), value: BLOOD_PRESSURE}, {name: this.$t(`${HDL_CHOLESTEROL}`), value: HDL_CHOLESTEROL}, {name: this.$t(`${LDL_CHOLESTEROL}`), value: LDL_CHOLESTEROL}, {name: this.$t(`${GLUCOSE}`), value: GLUCOSE}, {name: this.$t(`${TRIGLYCERIDES}`), value: TRIGLYCERIDES}, {name: this.$t(`${BLOOD_TYPE}`), value: BLOOD_TYPE}, {name: this.$t(`${BODY_MASS_INDEX}`), value: BODY_MASS_INDEX}, {name: this.$t(`${WAIST_SIZE}`), value: WAIST_SIZE}, {name: this.$t(`${HIP_SIZE}`), value: HIP_SIZE}, {name: this.$t(`${HEART_RATE}`), value: HEART_RATE}, {name: this.$t(`${BREATHING_FREQUENCY}`), value: BREATHING_FREQUENCY}, {name: this.$t(`${OXYGEN_SATURATION}`), value: OXYGEN_SATURATION}, {name: this.$t(`${FAT_MASS}`), value: FAT_MASS}, {name: this.$t(`${FREE_FAT_MASS}`), value: FREE_FAT_MASS}, {name: this.$t(`${HOMA}`), value: HOMA}, {name: this.$t(`${VITAMIN_D}`), value: VITAMIN_D}, {name: this.$t(`${STEPS_NUMBER}`), value: STEPS_NUMBER}, {name: this.$t(`${CALORIES}`), value: CALORIES}]
        }
    },
    methods: {
        updateActiveVars () {
            ClinicHistoryRepository().updateActiveVars(this.values.toString()).then(response => {
                let data = response.data.data
                if (data) {
                    this.$emit('activeVarsUpdated')
                    this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.revoke-access {
    cursor: pointer;
    color: $red;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryActiveVars.vue